import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const useDefaultMessages = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return {
    error: {
      title: i18n.t('upselling_kit.upselling_button.error_message.title'),
      description: i18n.t('upselling_kit.upselling_button.error_message.description'),
    },
    success: {
      title: i18n.t('upselling_kit.upselling_button.success_message.title'),
      description: i18n.t('upselling_kit.upselling_button.success_message.description'),
      buttonLabel: i18n.t('upselling_kit.upselling_button.success_message.button_label'),
      buttonOnClick: () => {
        navigate(navigation.discover.marketplaceModules.fullPath())
      },
    },
    nextSteps: {
      title: i18n.t('upselling_kit.upselling_button.next_steps.title'),
      items: [
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_1'), isCompleted: true },
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_2'), isCompleted: false },
        { text: i18n.t('upselling_kit.upselling_button.next_steps.item_3'), isCompleted: false },
      ],
    },
    loading: {
      label: i18n.t('upselling_kit.upselling_button.loading_state.label'),
    },
    close: i18n.t('upselling_kit.upselling_button.close_label'),
  }
}
